export class DumbCompanyAddress {
    id: number;
    street: string;
    city: string;
    state: string;
    zip: string;
    isPrimaryAddress: boolean;
    isDeleted: boolean;
    locationName: string;
    locationEmail: string;
    locationPhone: string;
    notes: string;
}
